import 'css-chunksrc/client/common/secondaryCriteriaForm/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_1vmk3_1",
  "input": "_input_1vmk3_5",
  "readOnly": "_readOnly_1vmk3_12",
  "disabled": "_disabled_1vmk3_18"
};